import _ from 'lodash';
import { getPullRequests as getPullRequestsApi } from 'common/services/pull-requests.service';
import { getPRsFailure, getPRsSucceed, resetPRs } from '../actions';

const getOptions = options => options || {};
const toStateModel = prs => ({ total: prs.length, items: prs });

const _getAllPrs = async params => {
  const limit = _.get(params, 'limit', 100);
  const response = await getPullRequestsApi({
    ...params,
    add_summary: true,
    limit
  });
  const { total } = response;
  let { items } = response;
  while (total > items.length) {
    const { items: newItems } = await getPullRequestsApi({
      ...params,
      add_summary: true,
      offset: items.length,
      limit
    });
    items = items.concat(newItems);
  }
  return { total, items };
};

export const getPullRequestsSingle = params => async dispatch => {
  try {
    const response = await getPullRequestsApi({
      ...params,
      add_last_activity: true
    });
    dispatch(getPRsSucceed(response));
    return response;
  } catch (e) {
    window.TrackJS && window.TrackJS.track(e);
    dispatch(getPRsFailure([]));
    return Promise.reject(e);
  }
};

export const getPullRequests = (paramsList, options) => async dispatch => {
  const { paginateAll = false } = getOptions(options);

  try {
    const prs = await Promise.all(
      paramsList.map(
        params =>
          new Promise(async resolve => {
            try {
              const response = paginateAll
                ? await _getAllPrs(params)
                : await getPullRequestsApi(params);
              resolve(response);
            } catch (e) {
              resolve(toStateModel([]));
            }
          })
      )
    );

    dispatch(
      getPRsSucceed(
        toStateModel(_.uniqBy(_.flatten(prs.map(pr => pr.items)), 'id'))
      )
    );
  } catch (e) {}
};

export const resetPullRequests = () => async dispatch => {
  try {
    dispatch(resetPRs());
  } catch (e) {}
};
